import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { Button } from 'storybook-ui'

import { selectAppName } from 'root-redux/selects/common'

import { useIsUsGeoRetentionFlow } from 'hooks/useIsUsGeoRetentionFlow'

import { SubscriptionContainer as Container } from 'common-styles'
import {
  APP_BUTTON_THEMES,
  APP_SECONDARY_BUTTON_THEMES,
  AppName,
  GROWTHBOOK_TEST_NAMES,
} from 'root-constants'

type TProps = {
  onClick: () => void
}

export const TurnOffRenewalButton: React.FC<TProps> = ({ onClick }) => {
  const { t } = useTranslation()
  const appName = useSelector(selectAppName) as AppName
  const isUsGeoRetentionFlow = useIsUsGeoRetentionFlow()
  const isFitmeSimplificationTest = useFeatureIsOn(
    GROWTHBOOK_TEST_NAMES.FITME_SIMPLIFICATION,
  )

  if (isUsGeoRetentionFlow) {
    return (
      <Button
        theme={APP_SECONDARY_BUTTON_THEMES[appName]}
        onClick={onClick}
        margin="16px auto"
      >
        {t('button.cancelSubscription')}
      </Button>
    )
  }

  return isFitmeSimplificationTest ? (
    <Button
      theme={APP_BUTTON_THEMES[appName]}
      onClick={onClick}
      style={{
        margin: '16px auto',
      }}
    >
      {t('subscription.stopSubscription')}
    </Button>
  ) : (
    <Container.ResetPassword onClick={onClick}>
      {t('subscription.turnOffRenewal')}
    </Container.ResetPassword>
  )
}
